/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Step 6 (Review & Confirm) tag for a composite. The reason under a dropped tag, and which side changed under replaced, are carried by rowStatusDetail.
 */
export enum SurveyReplacementReviewDiffRowStatus {
    REPLACED = 'replaced',
    NO_CHANGES = 'noChanges',
    DROPPED = 'dropped',
    NEW_MAPPING = 'newMapping',
}
